export function pluralise(value: number, single: string, multi?: string): string {
    return value > 1 ? (multi || `${single}s`) : single;
}
